import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMaterial from 'vue-material'
import 'roboto-fontface';
import 'material-icons';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './main.scss';


Vue.use(VueMaterial);
window.App.vue = new Vue({
  	router,
  	store,
	data:{},
  render: h => h(App)
}).$mount('#app');


